"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _svgIcon = _interopRequireDefault(require("../../svg-icon"));
var _colors = _interopRequireDefault(require("../../colors"));
var _excluded = ["size", "color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ArrowCaret = function ArrowCaret(_ref) {
  var size = _ref.size,
    color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_svgIcon["default"], _extends({
    size: size,
    viewbox: "0 0 64 64",
    path: "M8 48 L56 48 L32 12 Z",
    stroke: "none",
    id: "arrow",
    fill: color
  }, otherProps));
};
ArrowCaret.displayName = 'ArrowCaret';
ArrowCaret.propTypes = {
  size: _propTypes["default"].number,
  color: _propTypes["default"].string
};
ArrowCaret.defaultProps = {
  size: 24,
  color: _colors["default"].CORAL
};
var _default = exports["default"] = ArrowCaret;